// extracted by mini-css-extract-plugin
module.exports = {"AdSlotMail__mail":"bfw_a bgu_vf bgu_a bgu_q bgu_k","AdSlotMail__mail--notLoaded":"bfw_b bgu_eu bgu_bj bgu_vu","show-ad-not-loaded":"bfw_c","AdSlotMail__cta":"bfw_e"};